<template>
  <header class="header" v-show="routePath!='/photowall'">
    <!-- <div class="headerTop">
      <div class="htTip">
        <p>欢迎来到江苏冰谷数字科技有限官网!</p>
      </div>
    </div>-->
    <ul class="headerUl fwb">
      <!-- <img :src="require('../../assets/images/'+'c1.png')" /> -->
      <img class="backimgs" src="../../assets/images/c28.png" @click="goBack()" />
      <img class="homeimgs" src="../../assets/images/k10.png" @click="goHome()" />
      <img class="logo" src="../../assets/images/logo3.png" />
      <!-- <img class="logo" src="../../assets/images/c1.png" /> -->
      <div class="headerTab fwc">
        <img src="../../assets/images/c19.png" @click="headerTab()" />
      </div>
      <ul class="htUl animated fadeInRight" v-show="headerTabState">
        <router-link
          v-for="(item, index) in pages"
          v-bind:key="index"
          :index="index"
          :to="{ name: item.path, query: {} }"
          tag="li"
          :class="['htLi', { htActive: tabIndex == index }]"
          @click.native="goChild2(index)"
          replace
        >{{item.name}}</router-link>
      </ul>
      <div class="headerList fwc">
        <router-link
          v-for="(item, index) in pages"
          v-bind:key="index"
          :index="index"
          :to="{ name: item.path, query: {} }"
          tag="li"
          :class="['headerLi fhc', { headerActive: tabIndex == index }]"
          @click.native="goChild(index)"
          replace
        >
          <p class="p1">{{item.name}}</p>
          <p class="p2">{{item.en}}</p>
        </router-link>
        <a
          v-for="(item, index) in server"
          v-bind:key="index"
          :index="index"
          href="https://jsbingo.cn/pavilion/index1.html"
          tag="li"
          :class="['headerLi fhc']"
          @click.native="goChild3(index)"
          replace
        >
          <p class="p1">{{item.name}}</p>
          <p class="p2">{{item.en}}</p>
        </a>
        <router-link
          v-for="(item, index) in aboutus"
          v-bind:key="index"
          :index="index"
          :to="{ name: item.path, query: {} }"
          tag="li"
          :class="['headerLi fhc', { headerActive: tabIndex3 == index }]"
          @click.native="goChild3(index)"
          replace
        >
          <p class="p1">{{item.name}}</p>
          <p class="p2">{{item.en}}</p>
        </router-link>
      </div>
      <!-- <div class="headerTip fws">
        <div class="tip_tel fws">
          <img src="../../assets/images/c3.png" />
          <p class="fhss">
            <a>{{companys.telphone}}</a>
            <i>冰谷科技免费资讯热线</i>
          </p>
        </div>
      </div>-->
    </ul>
  </header>
</template>
<script>
import { Search } from "../../api/api";
import { mapMutations, mapGetters } from "vuex";
import _ from "lodash";
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?79c444958e7b91bba77ab2dbffcd261a";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
export default {
  data() {
    return {
      tabIndex: 0,
      tabIndex3: 1,
      imgPath: "../../assets/images/c1.png",
      headerTabState: false,
      pages: [
        { path: "/", name: "首页", en: "HOME" },
        { path: "product", name: "技术产品", en: "PRODUCT" },
        { path: "case", name: "案例分析", en: "CASE" },
        { path: "news", name: "新闻资讯", en: "NEWS" },
        // { path: "pavilion", name: "冰谷服务", en: "SERVER" },
        // { path: "aboutus", name: "关于我们", en: "ABOUTUS" }
      ],
      server: [{ path: "pavilion", name: "冰谷服务", en: "SERVER" }],
      aboutus: [{ path: "aboutus", name: "关于我们", en: "ABOUTUS" }],
      routePath: "",
      isBackHome: false
    };
  },
  props: {
    //选中
    tabActiveIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    loadDom() {
      this.activeRoute(this.$route.name);
    },
    goChild(index) {
      this.tabIndex = index;
      this.tabIndex3 = 1;
    },
    goChild3(index) {
      this.tabIndex = 4;
      this.tabIndex3 = index;
    },
    goChild2(index) {
      this.tabIndex = index;
      this.headerTabState = false;
    },
    headerTab() {
      this.headerTabState = !this.headerTabState;
    },
    activeRoute(routePath) {
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].path == routePath) {
          this.tabIndex = i;
        }
      }
    },
    goBack() {
      if (this.isBackHome) {
        this.$router.replace({
          path: "/"
        });
        return;
      }
      this.$router.go(-1);
    },
    goHome() {
      this.$router.replace({
        path: "/"
      });
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  watch: {
    $route(to, from) {
      this.activeRoute(to.name);
      this.routePath = this.$route.path;

      if (this.$route.path == "/aboutus") {
        // console.error('aboutus')
        this.tabIndex = 4
        this.tabIndex3 = 0
      }
      if (
        this.$route.path == "/home" ||
        this.$route.path == "/" ||
        this.$route.path == "/news" ||
        this.$route.path == "/case" ||
        this.$route.path == "/product" ||
        this.$route.path == "/aboutus"
      ) {
        if (!this.IsPC()) {
          if (this.$route.path == "/") {
            $(".backimgs").css("display", "none");
            $(".homeimgs").css("display", "none");
          } else {
            $(".backimgs").css("display", "none");
            $(".homeimgs").css("display", "block");
          }
          //this.isBackHome = true;
        }
      } else {
        if (!this.IsPC()) {
          $(".backimgs").css("display", "block");
          $(".homeimgs").css("display", "none");
          //this.isBackHome = false;
        }
      }
    }
  },
  components: {},
  created() {},
  mounted() {
    this.loadDom();
  },
  computed: {
    ...mapGetters(["companys"])
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/reset/reset.css";
@import "../../assets/css/reset/common.less";
@import "../../assets/css/fonts/iconfont.css";
@import "../../assets/css/home.css";
@import "../../assets/css/hover.css";

.header {
  width: 100%;
  height: @headerHeight;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  box-sizing: border-box;
  background: #fff;
  // box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  .headerTop {
    width: 100%;
    height: 30px;
    position: relative;
    background: #001c38;
    .htTip {
      width: @pcPageWidth;
      height: 100%;
      position: relative;
      left: 50%;
      margin-left: -@pcPageWidth / 2;
      overflow: hidden;
      p {
        color: #fff;
        font-size: 11px;
        display: inline-block;
        line-height: 1.45;
        letter-spacing: 2px;
      }
    }
  }
  .headerUl {
    width: @pcPageWidth;
    height: 80px;
    position: relative;
    left: 50%;
    margin-left: -@pcPageWidth / 2;
    // margin-left: calc(~"100% - @{pcPageWidth}");
    .logo {
      width: 136px;
      height: 40px;
      margin-left: 10%;
    }
    .headerList {
      width: 60%;
      height: 100%;
    }
    .headerActive {
      background: #ea5442;
    }
    .headerActive .p1,
    .headerActive .p2 {
      color: #fff !important;
      white-space: nowrap;
    }
    .headerActive:hover {
      color: #fff !important;
    }
    .headerLi {
      height: 100%;
      box-sizing: border-box;
      padding: 1px 16px;
      cursor: pointer;
    }
    .headerLi {
      margin-right: 6%;
    }
    .headerLi:last-child {
      margin-right: 0%;
    }
    .p1 {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      white-space: nowrap;
    }
    .p2 {
      color: #9a9a9a;
      font-size: 11px;
    }
    .headerLi:hover {
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      background: #ea5442;
      color: #fff;
    }
    .headerLi:hover .p1,
    .headerLi:hover .p2 {
      color: #fff !important;
    }
    .headerTip {
      width: 24%;
      height: 100%;
    }
    .tip_search {
      width: auto;
      height: 100%;
      margin-right: 10%;
    }
    .tip_search img {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      padding: 1px;
      margin-top: 2px;
      cursor: pointer;
    }
    .tip_tel {
      width: auto;
      height: 100%;
    }
    .tip_tel img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .tip_tel a {
      font-size: 16px;
      font-weight: bold;
      font-family: Arial;
      color: #e89212;
    }
    .tip_tel i {
      color: #9a9a9a;
      font-size: 12px;
    }
  }
  .headerTab,
  .backimgs,
  .homeimgs,
  .logo {
    display: none;
  }
  .headerUl {
    justify-content: center !important;
  }
}

@media screen and (min-width: 760px) and (max-width: 1024px) {
  .headerList {
    width: 92% !important;
  }
  .headerUl {
    width: 100% !important;
  }
  .headerList,
  .headerUl {
    left: 0 !important;
    margin-left: 0 !important;
  }
}

@media screen and (max-width: 720px) {
  .header .headerUl {
    justify-content: space-between !important;
  }
  .headerTab {
    display: block !important;
    width: auto;
    height: 100%;
    width: 42px;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    background: #ea5442;
    box-sizing: border-box;
    padding: 3%;
  }
  .headerTab img {
    width: 60%;
    height: 60%;
    display: block;
    position: absolute;
    top: 20%;
    left: 20%;
    z-index: 500;
  }
  .logo {
    display: block !important;
  }
  .htUl {
    position: fixed;
    top: 42px;
    right: 0;
    width: 60%;
    height: auto;
    z-index: 5000;
    float: left;
  }
  .htLi {
    width: 100%;
    float: left;
    height: 38px;
    background: #ea5442;
    font-size: 14px;
    text-align: center;
    line-height: 38px;
    border-bottom: solid 1px #fff;
    letter-spacing: 2px;
    color: #fff;
  }
  .htActive {
    border-bottom: solid 1px #333;
    color: #333;
  }
  .backimgs {
    box-sizing: border-box;
    width: 70px;
    height: 40px;
    padding: 11px 12px;
    display: block;
  }
  .homeimgs {
    box-sizing: border-box;
    width: 70px;
    height: 40px;
    padding: 11px 12px;
    object-fit: contain;
    display: block;
  }
  .header .headerUl .logo {
    height: 36px;
    object-fit: contain;
    position: absolute;
    left: 50%;
    margin-left: -54px !important;
    object-fit: contain;
  }
  .headerTop {
    display: none;
  }
  .header,
  .headerUl {
    height: 42px !important;
  }
}
.moveTip {
  animation: tipMove 18s linear infinite 0s;
}

@keyframes tipMove {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(1500px);
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?29fd31ee